import { Shipment } from '../models/shipment';
import { Package } from '../models/package';

function clonePackage(pkg: Package): Package {
    const commodities = [];
    pkg.commodities.forEach(item => {
        commodities.push({ ...item });
    });
    return {
        ...pkg,
        commodities
    };
}

export function cloneShipment(shipment: Shipment): Shipment {
    return {
        ...shipment,
        shipper: { ...shipment.shipper },
        destination: { ...shipment.destination },
        broker: { ...shipment.broker },
        soldTo: { ...shipment.soldTo },
        references: { ...shipment.references },
        packages: shipment.packages.map(pkg => ({
            ...pkg,
            quantity: +pkg.quantity || 1,
            weight: +pkg.weight || 1,
            width: +pkg.width || 1,
            height: +pkg.height || 1,
            length: +pkg.length || 1,
            value: +pkg.value || 0,
            commodities: pkg.commodities.map(commodity => ({
                ...commodity,
                quantity: +commodity.quantity || 1,
                netCost: +commodity.netCost || 0,
                weight: +commodity.weight || 1,
                pieces: +commodity.pieces || 1,
                price: +commodity.price || 0
            }))
        })),
        quote: { ...shipment.quote },
        pickup: { ...shipment.pickup },
        quotes: shipment.quotes ? shipment.quotes.map(quote => ({ ...quote })) : []
    };
}
